module.exports = __webpack_public_path__ + "img/about_csv_template_02.7c9da4c6.png";